<template>
  <main class="col-md-9 col-xl-8 pt-4 offset-xl-2">
    <ci-modal v-if="showModal">
      <ci-modal-header>Beitrag löschen</ci-modal-header>
      <ci-modal-body>Möchten Sie den Beitrag wirklich löschen?</ci-modal-body>
      <ci-modal-footer>
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="showModal = false; markedForDeletion = null;"
        >Schließen</button>
        <button type="button" class="btn btn-danger" @click="deletePost">Löschen</button>
      </ci-modal-footer>
    </ci-modal>

    <div class="d-flex align-items-center">
      <div>
        <h1 class="mb-0">Alle Beiträge</h1>
        <span class="text-muted" v-if="postCount > 0">Sie haben {{ postCount }} Beiträge</span>
        <span class="text-muted" v-else>Sie haben noch keine Beiträge</span>
      </div>
      <div class="ml-auto">
        <button class="btn btn-primary" @click="$router.push({ path: '/posts/create' })">Erstellen</button>
      </div>
    </div>
    <hr>
    <div class="row d-flex align-items-end">
      <div class="col-6">
        <ci-pagination
          v-if="postCount"
          :current-page="currentPage"
          :item-count="postCount"
          :items-per-page="10"
          @pagination:go-to-page="onGoToPage"
        />
      </div>
      <div class="offset-3 col-3">
        <ci-language-selector @language-selector:change="onLanguageChange"/>
      </div>
    </div>
    <ci-spinner v-if="!ready"/>
    <div v-if="ready">
      <div v-if="posts">
        <div v-for="post in posts" :key="`post-${post.id}`">
          <ci-post-item
            v-if="post.post_content && post.post_content.length"
            :post="post"
            @post-item:delete="onDeletePost"
          ></ci-post-item>
        </div>
      </div>
      <div v-else class="p-3 mt-2 bg-white d-flex">
        <div class="d-block">
          <div>
            <strong>Es wurden noch keine Beiträge angelegt.</strong>
          </div>
        </div>
      </div>
    </div>

    <ci-pagination
      class="mt-4"
      v-if="postCount"
      :current-page="currentPage"
      :item-count="postCount"
      :items-per-page="10"
      @pagination:go-to-page="onGoToPage"
    />
  </main>
</template>

<script>
// components
import LanguageSelector from '@/components/LanguageSelector.vue';
import Modal from '@/components/Modal.vue';
import ModalBody from '@/components/ModalBody.vue';
import ModalHeader from '@/components/ModalHeader.vue';
import ModalFooter from '@/components/ModalFooter.vue';
import Pagination from '@/components/Pagination.vue';
import PostItem from '@/components/posts/PostItem.vue';
import Spinner from '@/components/Spinner.vue';

// collection
import Collection from '@/collection';

// model
import PostModel from '@/models/PostModel';

// services
import PostService from '@/services/PostService';

export default {
  name: 'PostList',

  components: {
    'ci-language-selector': LanguageSelector,
    'ci-modal': Modal,
    'ci-modal-body': ModalBody,
    'ci-modal-footer': ModalFooter,
    'ci-modal-header': ModalHeader,
    'ci-pagination': Pagination,
    'ci-post-item': PostItem,
    'ci-spinner': Spinner,
  },

  data() {
    return {
      currentLanguage: 'de',
      currentPage: 1,
      makredForDeletion: null,
      posts: [],
      postCount: null,
      promise: null,
      ready: false,
      showCreateModal: false,
      showModal: false,
    };
  },

  created() {
    this.getPosts();
    this.countPosts();
  },

  methods: {
    countPosts() {
      const params = {
        language: this.currentLanguage,
      };
      PostService.count(params).then((count) => {
        this.postCount = parseInt(count, 10);
      });
    },

    deletePost() {
      PostService.delete(this.markedForDeletion).then(() => {
        this.showModal = false;
        this.getPosts();
        this.countPosts();
      });
    },

    onDeletePost(postId) {
      this.showModal = true;
      this.markedForDeletion = postId;
    },

    onGoToPage(page) {
      this.currentPage = page;
      const skip = (this.currentPage - 1) * 10;
      this.getPosts(skip);
    },

    getPosts(skip = 0) {
      this.ready = false;
      const params = {
        language: this.currentLanguage,
        limit: 10,
        offset: skip,
        orderBy: {
          created_at: 'DESC',
        },
      };

      PostService.findAll(params).then((posts) => {
        this.ready = true;
        const collection = new Collection(posts, PostModel);
        this.posts = collection.list;
      });
    },

    onLanguageChange(language) {
      this.currentLanguage = language;
      this.getPosts();
      this.countPosts();
    },

    onCreatePost() {
      this.showCreateModal = true;
    },
  },
};
</script>
